var _rect, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 7,
    fill: "url(#paint0_linear_197_687)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.828 21.672C22.6075 21.871 22.321 21.9812 22.024 21.9812C21.727 21.9812 21.4405 21.871 21.22 21.672L11.044 12.42C11.4433 12.1465 11.916 12.0001 12.4 12H31.6C32.084 12.0001 32.5567 12.1465 32.956 12.42L22.828 21.672Z",
    fill: "url(#paint1_linear_197_687)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 14.712V27.6C34 28.5548 33.6207 29.4705 32.9456 30.1456C32.2705 30.8207 31.3548 31.2 30.4 31.2H13.6C12.6452 31.2 11.7295 30.8207 11.0544 30.1456C10.3793 29.4705 10 28.5548 10 27.6V14.712L20.416 24.216C20.8553 24.5975 21.4182 24.8065 22 24.804C22.5891 24.8028 23.1571 24.585 23.596 24.192L34 14.712Z",
    fill: "url(#paint2_linear_197_687)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_197_687",
    x1: -5.90244,
    y1: -5.36585,
    x2: 44,
    y2: 48.8293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A31F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A31F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_197_687",
    x1: 12.5,
    y1: 12,
    x2: 32,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_197_687",
    x1: 12.5,
    y1: 12,
    x2: 32,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.f9f2f257bf131d7cd0ab2ad94e17ef5d.svg";
export { ForwardRef as ReactComponent };